__turbopack_context__.v({
  "dest": "SrcDest-module-scss-module__hYPHCW__dest",
  "loading": "SrcDest-module-scss-module__hYPHCW__loading",
  "lorrySrcDestBox": "SrcDest-module-scss-module__hYPHCW__lorrySrcDestBox",
  "popup": "SrcDest-module-scss-module__hYPHCW__popup",
  "route": "SrcDest-module-scss-module__hYPHCW__route",
  "routeWrapperMobile": "SrcDest-module-scss-module__hYPHCW__routeWrapperMobile",
  "routes": "SrcDest-module-scss-module__hYPHCW__routes",
  "source": "SrcDest-module-scss-module__hYPHCW__source",
  "sourceDestWrap": "SrcDest-module-scss-module__hYPHCW__sourceDestWrap",
  "viewStates": "SrcDest-module-scss-module__hYPHCW__viewStates",
});
